const dateToShortDate = (date) => {
  const dateStr = `
    ${date.toLocaleString('default', { month: 'short' })}
    ${date.getDate()},
    ${date.getFullYear()}
  `;
  return dateStr;
};

const convertToShortDate = (longDateStr) => {
  const date = typeof longDateStr === 'string' ? new Date(longDateStr) : longDateStr;
  return dateToShortDate(date);
};

const unixToShortDate = (unix) => {
  const date = new Date(unix * 1000);
  return dateToShortDate(date);
};

export { convertToShortDate, unixToShortDate };
